import { render, staticRenderFns } from "./SystemActivityCampaign.vue?vue&type=template&id=2b64f489"
import script from "./SystemActivityCampaign.vue?vue&type=script&lang=js"
export * from "./SystemActivityCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports